import { useEffect, useState } from 'react';
import {
  checkSignInAndGetUserAuthToken,
  getDeviceInfomation,
  getUserAuthAccount,
  isMobileHost,
  addPrinterSelectedListener
} from 'jweb';
import { encryptData, getOtherPageInfo } from '../utils/analytics';
import {
  setEncryptedUDLData,
  setJwt,
  setPrinterInfo,
  setRawUDLData,
  setSession,
  setAuthAccount,
  setMobileHost,
  setAppId,
  setLocale,
  getCurrentJwt,
  getPrinterInfo,
  setInitialPrinterDataFetched,
  getArchitecture,
  setArchitecture,
  setManufacturer
} from '../utils/persistData';
import { fetchEngagements } from '../utils/request';

const setUDLData = async () => {
  try {
    const otherPageInfo = getOtherPageInfo();
    setRawUDLData(otherPageInfo);
    const encryptedData = await encryptData(otherPageInfo);
    delete encryptedData.data.date_encrypted;
    setEncryptedUDLData(encryptedData.data);
    return true;
  } catch (error) {
    return true;
  }
};

const getInitData = async params => {
  try {
    const data = await fetchEngagements({ ...params, ruleType: 'dataDriven' });
    console.log(data, 'initialFetchData');
    return data;
  } catch (error) {
    return null;
  }
};

const getPrinterData = async () => {
  const onPrinterChange = printerInfo => {
    let { PrinterUUID = '', PrinterProductNumber = '', SessionId = '' } = printerInfo;
    const currentPrinterInfo = getPrinterInfo();
    if (
      PrinterUUID !== currentPrinterInfo.device_uuid ||
      PrinterProductNumber !== currentPrinterInfo.product_number ||
      SessionId !== currentPrinterInfo.printer_sessionId
    ) {
      setPrinterInfo(printerInfo);
      setInitialPrinterDataFetched(true);
    }
  };
  try {
    const printerData = await addPrinterSelectedListener(onPrinterChange);
    return printerData;
  } catch (e) {}
};

const eraseSessionStorage = () => {
  sessionStorage.removeItem('tilesSeen');
};

const getInfoFromApp = async params => {
  try {
    const appCalls = [
      checkSignInAndGetUserAuthToken(false),
      getUserAuthAccount(false),
      isMobileHost(),
      getDeviceInfomation()
    ];

    const [token, authAccount, mobileHost, deviceInfo] = await Promise.all(appCalls);
    return [
      token,
      authAccount,
      mobileHost,
      deviceInfo.appVersion,
      deviceInfo.architecture || '',
      deviceInfo.manufacturer || ''
    ];
  } catch (error) {
    return ['', {}, false, ''];
  }
};

export const useInitialFetch = params => {
  const [widgetData, setWidgetData] = useState(null);
  const [isInitialFetching, setIsInitialFetching] = useState(false);

  useEffect(() => {
    const getData = async () => {
      setIsInitialFetching(true);
      eraseSessionStorage();
      const [token, authAccount, mobileHost, appVersion, architecture, manufacturer] =
        await getInfoFromApp(params);
      setAppId(params.appInstanceId);
      setArchitecture(architecture);
      setManufacturer(manufacturer);
      setLocale(params.locale);
      setJwt(token);
      if (authAccount) {
        setAuthAccount(authAccount);
      }
      setMobileHost(mobileHost);
      params.version = appVersion;
      params.architecture = architecture;
      params.sysManufacturer = manufacturer;
      const printerInfo = await getPrinterData();

      const initialFetchPromises = [setUDLData(), getInitData(params)];
      const [udldData, data] = await Promise.all(initialFetchPromises);
      if (data && udldData) {
        console.log(data, 'widgetData');
        setWidgetData(currentData => {
          if (!currentData?.engagements?.length) {
            setIsInitialFetching(false);
            return data;
          }
        });
      }
    };

    if (!widgetData) {
      if (params.deviceID || params.product_number) {
        setPrinterInfo({
          PrinterUUID: params.deviceID,
          PrinterProductNumber: params.product_number,
          SessionId: params.printerSessionId,
          totalPrinters: params.totalPrinters,
          isHpxScanSupported: params.isHpxScanSupported
        });
      }

      if (params.sessionId) {
        setSession(params.sessionId);
      }

      if (params.bgColor) {
        document.body.style.backgroundColor = `#${params.bgColor}`;
      }
      getData();
    }
  }, [widgetData]);

  return {
    widgetData,
    isInitialFetching
  };
};
